import React from 'react'

const Footer = () => {
  return (
    <footer className='bg-primary-darker py-[24px] text-white text-sm text-center'>
      
        
          <p className='pt-5'>
            Address: 115 A. Pichon St., Brgy. 39-B, Davao City <br />
            Contact Nos.: 0922-479-1034 / 0906-578-4565 <br />
            Email Address: cyddpms215@gmail.com <br />
          </p>
      
        
          <p className='pt-5 pb-4 text-lg font-bold text-accent'>2023 &copy; Cristina Cyd Borre</p>
        
      
    </footer>
  )
}

export default Footer 